import * as Yup from "yup"

export interface TransactionMessageFlow {
    id: string;
    name: string;
}

export interface TransactionMessageScope {
    id: string;
    name: string;
}

export interface TransactionMessageReference {
    id: string;
    reference: string;
    referenceTypeText: string;
    isPrimary: boolean;
}

export interface TransactionMessageType {
    id: string;
    name: string;
}

export interface TransactionMessageTypeName {
    typeName: TransactionMessageType
}

export enum TransactionMessageProcessingStatus {
    ACTIVE = "ACTIVE",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DROPED = "DROPED"
}

export interface TransactionMessageStatus {
    processingStatus: TransactionMessageProcessingStatus;
}

export interface TransactionMessageDefinitionsResponse {
    scopes: TransactionMessageScope[],
    types: TransactionMessageType[],
    flows: TransactionMessageFlow[]
}

export interface TransactionMessage {
    id: string;
    createdAt: Date;
    createdBy: string;
    flow: TransactionMessageFlow;
    scope: TransactionMessageScope;
    references: TransactionMessageReference[];
    types: TransactionMessageTypeName[];
    status: TransactionMessageStatus;
}

export interface PaginatedTransactionMessagesResponse {
    data: TransactionMessage[];
    nextCursor: string | null;
    hasNextPage: boolean;
    message?: string;
}

export interface TransactionMessagesFilters {
    reference?: string | null;
    scopeId?: string | null;
    messageTypeId?: string | null;
    processingStatus?: string | null;
    flowId?: string | null;
    createdAtFrom?: string;
    createdAtTo?: string;
};

export interface TransactionMessagesRequest extends TransactionMessagesFilters {
    cursor?: string | null,
    limit?: number | null
};

export interface TransactionMessageIssueSeverity {
    id: string;
    name: string;
    allowNotification: boolean;
    createdAt: string;
    createdBy: string;
}

export interface TransactionMessageErrorDetails {
    id: string;
    errorText: string;
    errorFormat: string;
    createdAt: string;
    createdBy: string;
}

export interface TransactionMessageIssueResponse {
    id: string;
    severity: TransactionMessageIssueSeverity;
    errorDetails: TransactionMessageErrorDetails;
    createdAt: string;
    createdBy: string;
}

export interface TransactionMessageDump {
    id: string;
    messageData: string;
    messageDataFormat: string;
    createdAt: string;
    createdBy: string;
}

export interface TransactionMessageReprocessRequest{
    scopeId: string;
    messageTypeId: string;
    references: TransactionMessageReference[]
}

export interface TransactionMessageReprocessResponse{
   result: boolean,
   message?: string
}

export interface TransactionMessageReprocessData{
    scopeId: string;
    messageTypeId: string;
    reference: string;
}

export const TransactionMessagesFiltersSchema: Yup.ObjectSchema<TransactionMessagesFilters> = Yup.object().shape({
    reference: Yup.string().nullable(),
    scopeId: Yup.string().nullable(),
    messageTypeId: Yup.string().nullable(),
    processingStatus: Yup.string().nullable(),
    flowId: Yup.string().nullable(),
    createdAtFrom: Yup.string(),
    createdAtTo: Yup.string(),
    probillStatus: Yup.string().nullable()
}).defined();

export const TransactionMessagesReprocessRequestSchema: Yup.ObjectSchema<TransactionMessageReprocessData> = Yup.object().shape({
    reference: Yup.string().required(),
    scopeId: Yup.string().required(),
    messageTypeId: Yup.string().required()
}).defined();